import { defineStore } from "pinia";
import { api } from "@/helpers/api.js";
import { startDownload } from "../helpers/download.js";

export const useBookingsStore = defineStore("bookings", {
  state: () => ({
    bookings: [],
    bookingorders: [],
    bookingorder_filter_bookings: [],
    pager: {
      page: 1,
      page_size: 25,
      total_size: 0,
      total_pages: 0,
    },
    query: {
      sorting: "created:desc",
    },
    bookingorder: null,
    conditions: [],
  }),
  actions: {
    downloadTicketsAsZip(payload) {
      const { bookingOrderId, fileName } = payload;
      let uri = `etickets/download/zip/${bookingOrderId}`;
      return api
        .get(uri)
        .then((res) => {
          startDownload(res.data, `tickets-${fileName.toLowerCase()}.zip`);
        })
        .catch((e) => {
          throw e;
        });
    },
    async downloadBookingOrderExtra(payload) {
      const { bookingOrderId, bookingOrderExtraId } = payload;
      const getUri = `bookingorders/${bookingOrderId}/extras/${bookingOrderExtraId}/download`;
      const response = await api.get(getUri, { responseType: "arraybuffer" });
      return response.data;
    },
    async fetchBookingOrderExtras(payload) {
      const { bookingOrderId } = payload;
      let getUri = `bookingorders/${bookingOrderId}/extras`;
      const response = await api.get(`${getUri}`);
      return response.data.bookingorderextras;
    },
    downloadSingleTicket(payload) {
      const { bookingorderId, orderItemId, url, dayIdx } = payload;
      if (!!url) {
        if (url.toLowerCase().endsWith("pkpass")) {
          const getUri = `etickets/download/pkpass/${bookingorderId}/${orderItemId}/url/${url}`;
          return api
            .get(getUri)
            .then((res) => {
              startDownload(url);
            })
            .catch((e) => {
              throw e;
            });
        } else {
          const seconds = Math.floor(Date.now() / 1000);
          const getUri = `etickets/download/${bookingorderId}/${orderItemId}/url/${url}?key=${seconds}`;
          return api
            .get(getUri, { responseType: "blob" })
            .then((res) => {
              const url = window.URL.createObjectURL(res.data);
              startDownload(url, `ticket-${orderItemId}`);
            })
            .catch((e) => {
              throw e;
            });
        }
      }
    },

    async getTicketsForBranded(bookingId) {
      const req = api.get(`bookingorders/restricted/${bookingId}`);
      const res = await req;
      this.bookingorders = res.data.bookingorders;
    },

    saveEmail(payload) {
      return api
        .post(`bookingorders/restricted/${payload.bookingorderId}/notify`, payload)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },

    async fetchBookingOrderGuestdata(bookingorderId) {
      const res = await api.get(`bookingorders/${bookingorderId}/guestdata?include_conditions=true`);
      this.setGuestData(res.data.items);
      return res.data;
    },

    setGuestData(items) {
      this.conditions = items.map((item) => {
        return {
          ...item,
          guests: item.guests.map((guest) => {
            const values = {};
            for (const k in guest) {
              values[k] = guest[k].value || "";
            }
            values.guest_id = guest.guest_id || undefined;
            values.lead_guest = guest.lead_guest;
            return values;
          }),
        };
      });
    },
  },
});
